import { Container, Graphics, Text } from 'pixi.js'
import { DropShadowFilter } from '@pixi/filter-drop-shadow'
import type { BulletStyle } from '@/scripts/config/settings'

export function createBulletContainer(dayLabel: number, isLeft: boolean, style: BulletStyle): Container {
  const bulletContainer = new Container()

  const bullet = new Graphics()
  bullet.lineStyle(2, style.BULLET_NUMBER_STROKE_COLOR)
  bullet.beginFill(style.BULLET_NUMBER_BACKGROUND_COLOR, style.BULLET_NUMBER_BACKGROUND_ALPHA)
  bullet.drawCircle(0, 0, style.BULLET_RADIUS)
  bullet.endFill()
  bulletContainer.addChild(bullet)
  bulletContainer.filters = [
    new DropShadowFilter({
      color: 0x306d84,
      offset: { x: isLeft ? -2 : 2, y: 2 },
      quality: 20,
      pixelSize: 2,
      blur: 0,
      resolution: 2,
      alpha: 0.25,
    }),
  ]

  if (dayLabel > 0) {
    const bulletNumberText = new Text(dayLabel, {
      fontFamily: style.FONT_BASE,
      fontWeight: '500',
      fontSize: '18px',
      fill: style.BULLET_NUMBER_TEXT_COLOR,
    })
    bulletNumberText.anchor.x = 0.5
    bulletNumberText.anchor.y = 0.5
    bulletContainer.addChild(bulletNumberText)
  } else {
    const bulletDot = new Graphics()
    bulletDot.beginFill(style.DOT_COLOR)
    bulletDot.drawCircle(0, 0, style.DOT_RADIUS)
    bulletDot.endFill()
    bulletContainer.addChild(bulletDot)
  }

  return bulletContainer
}
